<h2 mat-dialog-title>Printer fout!</h2>
<hr/>
<mat-dialog-content><p>Er is een fout opgetrijden tijdens het printer, controleer de printer. wilt u het printen nogmaals proberen?</p></mat-dialog-content>
<mat-dialog-actions >
    <button mat-button (click)="close()" [mat-dialog-close]="true">Opnieuw</button>
    <button mat-button (click)="cancel()" [mat-dialog-close]="false">Annuleren</button>
</mat-dialog-actions>